import React from "react";

const GolfCartIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 21 19"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8311,-0.033v1.151h-17.8311v-1.151z"
        fill="currentColor"
      />
      <path
        d="M0.5219,7.834c0,-1.262 1.0231,-2.246 2.2822,-2.246h3.291c1.4344,0 2.7565,0.771 3.4473,1.995l1.0654,1.879h2.9121v1.15h-3.582l-1.3955,-2.461l-0.001,-0.002c-0.4841,-0.858 -1.4212,-1.411 -2.4463,-1.411h-3.291c-0.6469,0 -1.1318,0.492 -1.1318,1.096v6.978h18.21v-2.844c-0.0002,-0.995 -0.84,-1.834 -1.8858,-1.834h-0.3818l-3.9375,-9.369l1.0595,-0.445l3.6534,8.692c1.4768,0.191 2.6414,1.436 2.6416,2.956v3.993h-20.5098z"
        fill="currentColor"
      />
      <path
        d="M2.8359,0.542v5.622h-1.1504v-5.622z"
        fill="currentColor"
      />
      <path
        d="M8.4443,15.81c0,1.552 -1.2966,2.821 -2.8813,2.821c-1.5847,0 -2.848,-1.269 -2.848,-2.821c0,-1.552 1.2744,-2.789 2.848,-2.789c1.5736,0 2.8813,1.248 2.8813,2.789z"
        fill="#1A8B5A"
      />
      <path
        d="M18.7504,15.81c0,1.552 -1.2966,2.821 -2.8813,2.821c-1.5847,0 -2.848,-1.269 -2.848,-2.821c0,-1.552 1.2744,-2.789 2.848,-2.789c1.5736,0 2.8813,1.248 2.8813,2.789z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default GolfCartIcon;
